import React from 'react';
import {STORAGE_KEYS} from '../../utils/constants';
import {SessionStorage} from '@chekin/core';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';

export function useSignatureState() {
  const [signature, setInternalSignature] = React.useState('');
  const {isMatch: isMobile} = useScreenResize(DEVICE.laptop);

  const setSignature = React.useCallback((signatureDataURL: string) => {
    setInternalSignature(signatureDataURL);
    SessionStorage.set(STORAGE_KEYS.personalSignatureFormData, signatureDataURL);
  }, []);

  const resetSignature = React.useCallback(() => {
    setInternalSignature('');
    SessionStorage.remove(STORAGE_KEYS.personalSignatureFormData);
  }, []);

  React.useEffect(() => {
    if (isMobile) {
      SessionStorage.set(STORAGE_KEYS.personalSignatureFormData, signature);
    }
  }, [signature, isMobile]);

  return {
    signature,
    setSignature,
    resetSignature,
  };
}
